export const DEFAULT_EMAIL_FIELDS = [
    {
        name: 'email',
        type: 'email',
        label_ru: 'Email',
    },
    {
        name: 'name',
        type: 'name',
        label_ru: 'Имя',
    },
];
